import React, { FC } from 'react';
import { Box, Card, Grid, IconButton, Typography } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { FileDropzone } from 'src/UIKit/FileDropzone';
import { Iconify } from 'src/UIKit/Iconify';
import { Image } from 'src/UIKit/Image';
import { observer } from 'mobx-react';
import { nltdevskeletonsModel } from 'src/modules/nltdevskeletons/entity/nltdevskeletons/NltdevskeletonsModel';

export const NltdevskeletonImageDropZone: FC = observer(() => {
    const { t } = useUiContext();
    const nltdevskeleton = nltdevskeletonsModel.nltdevskeleton;

    const onChangeImage = (files: File[]) => {
        if (nltdevskeleton && files?.[0]) {
            nltdevskeletonsModel.nltdevskeleton = { ...nltdevskeleton, image: files?.[0] as any };
        }
    }

    const omRemoveImage = () => {
        if (nltdevskeleton) {
            nltdevskeletonsModel.nltdevskeleton = { ...nltdevskeleton, image: null };
        };
    };

    return (
        <Card sx={{ p: 2, mb: 2 }}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={3.5} md={3.5} lg={3.5}  >
                    <Typography variant='h6' mb={2} >{t('content.contentIcon')}</Typography>
                    {nltdevskeleton?.image ? <Box display={'flex'} flexDirection={'row'} >
                        <Image image={nltdevskeleton?.image} sx={{ width: 110, height: 110, borderRadius: 1.5, objectFit: 'contain' }} />
                        <IconButton sx={{ height: 50, width: 50 }} onClick={omRemoveImage}>
                            <Iconify icon={'eva:trash-2-outline'} />
                        </IconButton>
                    </Box> : null}
                </Grid>
                <Grid item xs={12} sm={8.5} md={8.5} lg={8.5}  >
                    <FileDropzone onDrop={onChangeImage} />
                </Grid>
            </Grid>
        </Card>
    );
})
